import { render } from "./modal-crea-task.vue?vue&type=template&id=5474f50a&scoped=true"
import script from "./modal-crea-task.vue?vue&type=script&lang=js"
export * from "./modal-crea-task.vue?vue&type=script&lang=js"

import "./modal-crea-task.vue?vue&type=style&index=0&id=5474f50a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5474f50a"]])

export default __exports__